export const GET_PATIENT_DROPDOWN_LIST = "GET_PATIENT_DROPDOWN_LIST"
export const GET_PATIENT_DROPDOWN_LIST_FAIL = "GET_PATIENT_DROPDOWN_LIST_FAIL"
export const GET_PATIENT_DROPDOWN_LIST_SUCCESS = "GET_PATIENT_DROPDOWN_LIST_SUCCESS"
export const GET_PATIENT_DROPDOWN_LIST_RESET = "GET_PATIENT_DROPDOWN_LIST_RESET"

export const getPatientDropdownList = (params) => {
    return { type: GET_PATIENT_DROPDOWN_LIST, params }
}

export const getPatientDropdownListSuccess = (response) => {
    return { type: GET_PATIENT_DROPDOWN_LIST_SUCCESS, response }
}

export const getPatientDropdownListFail = (response) => {
    return { type: GET_PATIENT_DROPDOWN_LIST_FAIL, response }
}

export const getPatientDropdownListReset = () => {
    return { type: GET_PATIENT_DROPDOWN_LIST_RESET }
}